<div class="progress-circle" [ngClass]="'p'+[progessValue]">
    <span>{{progessValue}}%</span>
    <div class="left-half-clipper">
        <div class="first50-bar"></div>
        <div class="value-bar"></div>
    </div>
</div>